<template>
  <v-footer color="transparent" class="pt-8" padless>
    <v-card color="transparent" flat tile class="flex lighten-1 text-center">
      <v-card-text id="icons">
        <v-btn v-for="icon in icons" :key="icon.icon" :href="icon.link" target="_blank" text
          class="text-none subtitle-1 mt-0 pt-0 mr-0" :ripple="false" color="#60a9ff">
          <!-- <v-icon class="bl" size="24px">
            {{ icon.icon }}
          </v-icon> -->
          <p class="bl px-10 mx-10">
            {{ icon.text }}
          </p>
        </v-btn>
      </v-card-text>

      <!-- <v-divider></v-divider> -->
      <v-card-text id="date" color="transparent">
        {{ new Date().getFullYear() }} —
        <strong color="#60a9ff">UNIVERSTAT</strong>
      </v-card-text>

      <v-card-text class="mt-0 pt-0">
        <v-btn to="agreement" text class="text-none subtitle-2 mt-0 pt-0 mr-0" :ripple="false" color="#60a9ff">
          Пользовательское соглашение
        </v-btn>
        <div>ИНН: 772979124364</div>
      </v-card-text>
<!--      <v-card-text class="mt-0 pt-0">-->
<!--        <v-btn href="https://t.me/SatorAlex" target="_blank" text class="text-none subtitle-2 mt-0 pt-0 mr-0"-->
<!--          :ripple="false" color="#60a9ff">-->
<!--          Гундарев Александр Анатольевич-->
<!--        </v-btn>-->
<!--      </v-card-text>-->
<!--     <v-card-text> -->
<!--       <a style="text-decoration:none; color:#60a9ff" target="_blank" href="https://t.me/mlybiev">Made by malter</a> -->
<!--     </v-card-text> -->
    </v-card>
  </v-footer>
</template>


<script>
export default {
  data: () => ({
    icons: [
      {
        icon: "mdi-telegram",
        text: "Telegram",
        link: "https://t.me/universtat_database",
      },
      { icon: "mdi-vk", text: "VK", link: "https://vk.com/universtat" },
      // { icon: "mdi-instagram", link: "http://instagram.com/kirill.aparin" },
    ],
  }),
};
</script>


<style scoped>
i.v-icon.v-icon {
  color: #60a9ff;
}

.theme--light.v-card>.v-card__subtitle,
.theme--light.v-card>.v-card__text {
  color: #60a9ff;
}
</style>
